import AppHome from './AppHome.vue';
export default [
  {
    path: '',
    name: 'AppHome',
    component: AppHome
  }
];
